module.exports = __webpack_public_path__ + "static/media/spicy-dill-mama-dt-fr.c6f5202c.jpg";